module.exports = __webpack_public_path__ + "assets/img/slow_cook_active.b083680b.png";